// extracted by mini-css-extract-plugin
module.exports = {"root":"OfficeMap_root__2CcvP"};